import React, { PropsWithChildren } from 'react';
import clsx from 'clsx';

interface NoDataFoundProps {
  trigger: boolean;
  title?: string;
  message?: string;
  height?: string | number;
  actions?: React.ReactNode[];
  bordered?: boolean;
  component?: React.ReactNode;
}

export const NoDataFound = ({
  title = 'No Data Found',
  trigger,
  message = 'Try a different search or filter',
  actions = [],
  children,
  height = 300,
  bordered = false,
  component,
}: PropsWithChildren<NoDataFoundProps>) => {
  if (!trigger) return <React.Fragment>{children}</React.Fragment>;

  if (component) return <React.Fragment>{component}</React.Fragment>;

  return (
    <div
      id="no-data-message"
      className={clsx('flex flex-col items-center justify-center w-full', {
        'border tg-border-color rounded': bordered,
      })}
      style={{ height }}
    >
      <p className="font-bold text-lg">{title}</p>
      <p className="opacity-70">{message}</p>
      <div
        id="no-data-actions"
        className="flex flex-col sm:flex-row items-center gap-3 mt-4"
      >
        {actions.map((action, index) => (
          <React.Fragment key={`action-${index + 1}`}>{action}</React.Fragment>
        ))}
      </div>
    </div>
  );
};
